import types from './types'


export const setEditorLog = (editorlog) => ({
  type: types.SET_EDITORLOG,
  editorlog
})